import { useEffect } from 'react';

/**
 * Calls `handler` when a click/mousedown lands outside `ref.current`.
 * Replaces the 12+ hand-rolled copies scattered across components.
 */
export default function useClickOutside(ref, handler, active = true) {
  useEffect(() => {
    if (!active) return;
    const listener = (e) => {
      if (!ref.current || ref.current.contains(e.target)) return;
      handler(e);
    };
    document.addEventListener('mousedown', listener);
    return () => document.removeEventListener('mousedown', listener);
  }, [ref, handler, active]);
}
